import React from "react"
import {AccountBalanceWallet, CreditCard} from "@mui/icons-material";

/** Index 1–8: wal_N and card_N share the same palette entry. Index 0 unused. */
const WALLET_COLOR_PALETTE = [
    "",
    "#15854E",
    "#19B65B",
    "#EB5757",
    "#BB6BD9",
    "#2F80ED",
    "#00BCD4",
    "#CAA83F",
    "#828282",
];

const DEFAULT_COLOUR = "#aaa";

const WalletIcon = ({image, sx}) => {
    const defaultIcon = (
        <AccountBalanceWallet fontSize="large" sx={{...sx, color: DEFAULT_COLOUR}} />
    );

    if (!image) {
        return defaultIcon;
    }
    if (!image.id) {
        return defaultIcon;
    }

    const id = image.id;

    if (id >= 1 && id <= 16) {
        const colorIndex = id <= 8 ? id : id - 8;
        const iconColor = WALLET_COLOR_PALETTE[colorIndex] || DEFAULT_COLOUR;
        if (id <= 8) {
            return <AccountBalanceWallet fontSize="large" sx={{...sx, color: iconColor}} />;
        }
        return <CreditCard fontSize="large" sx={{...sx, color: iconColor}} />;
    }

    return defaultIcon;
}

export default WalletIcon
